<template>
    <div>
        <Uediter :khId="khId" :qyId="qyId"></Uediter>
    </div>
</template>
<script>
    import Uediter from './ueditor'
    import { getCompanyCaseById } from '../api/api.js'
    export default {
        components: { Uediter },
        created() {
            this.khId = this.$route.query.khId;
            this.qyId = this.$route.query.qyId;
        },
        data() {
            return {
                khId: '',
                qyId: ''
            }
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ht_customCase.vue